import { useAppSelector } from "app/redux.store";
import { CLOSE_ALL_OVERLAYS, OpenFixrOverlayMenuAction, OPEN_FIXR_OVERLAY } from "layout/redux/overlay.actions";
import { useDispatch } from "react-redux";

export default (content?: string, theme?: any) => {
    const dispatch = useDispatch();
    const overlay = useAppSelector(state => state.overlay);

    const toggleFixrOverlay = () => {
        setTimeout(() => {
            if (overlay.currentOverlay !== "FIXR_OVERLAY") {
                dispatch({
                    type: OPEN_FIXR_OVERLAY,
                    content: content
                } as OpenFixrOverlayMenuAction);
            }
            else {
                dispatch({
                    type: CLOSE_ALL_OVERLAYS
                });
            }
        }, 50);
    };

    return { toggleFixrOverlay };
};